<template>
  <div
    v-if="initialLoading"
    class="sights-list-wrapper"
  >
    <slot />
  </div>
  <div
    v-else
    v-view-section-tracker="getSectionViewParams()"
    class="sights-list-wrapper"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
  import { storeToRefs } from 'pinia';
  import { computed, ref, watch } from 'vue';

  import { useSightEntity } from '@/entities/sight';
  import { useViewTracker } from '@/services/analytics';

  interface Props {
    /**
     * Идентификатор города.
     */
    subjectGeoId: number;

    /**
     * Название города.
     */
    subjectGeoName: string;

    /**
     * Флаг загрузки сторонних данных.
     *
     * Данный флаг нужен для того, чтобы не отсылать события аналитики до того
     * как загрузятся все данные, отправляемые в событиях.
     */
    generalPageDataLoading: boolean;
  }

  const props = defineProps<Props>();

  const sightEntity = useSightEntity();
  const { loading: sightLoading } = storeToRefs(sightEntity);
  const initialLoading = ref(true);
  const loading = computed(() => sightLoading.value || props.generalPageDataLoading);

  const vViewSectionTracker = useViewTracker('city-articles-info:section.view');

  const getSectionViewParams = () => ({
    subject_geo_id: props.subjectGeoId,
    subject_geo_name: props.subjectGeoName,
    subject_geo_type: 'city',
    section_type: 'sight',
  });

  watch(
    () => loading.value,
    () => {
      if (!loading.value) {
        initialLoading.value = false;
      }
    },
  );
</script>
